// Browser-safe subset of this package's exports — no `pg`/drizzle-orm anywhere in this
// module's import graph. Import this (`@ii-gp-widget/shared/browser`) from any code that
// gets bundled for a browser (the widget); importing the main `@ii-gp-widget/shared` entry
// from browser code pulls in the DB repository layer transitively, and `pg` depends on
// several Node built-ins (`net`, `fs`, `dns`, ...) that don't exist in a browser bundle.
export type { Locale, SharedConfig } from "./config";
export { sharedConfig } from "./config";

// Types only from here down — no runtime import. `fetchAvailability`/`predictHours`/
// `getWeekdayHistory` are deliberately NOT re-exported: the widget never calls the
// availability API directly or computes predictions itself, it only renders what the render/
// poll endpoints already computed — and `predictHours` pulls in `date-fns`/`date-fns-tz`,
// which are CJS and don't tree-shake, adding >100kb of unused code to the bundle for nothing.
export type {
  AvailabilityCategory,
  AvailabilityHistoryPoint,
  AvailabilityResult,
} from "./availability/types";
export type {
  HourlyPrediction,
  PredictHoursOptions,
  WeekdayHourPoint,
  WeekdayCategorySeries,
} from "./predictions/predict";

export { computeThemeTokens, generateBarColors, THEME_SIZES, BUILT_IN_THEME_NAMES } from "./theme/theme";
export type {
  ThemeTokens,
  ThemeSizeTokens,
  ThemeThickness,
  CustomThemeInput,
  BuiltInThemeName,
} from "./theme/theme";

export { parseHourRange } from "./settings/hours";
export type { HourRange } from "./settings/hours";

export { parseMaxWidth } from "./settings/max-width";

export { FONT_SIZES, parseFontSize } from "./settings/font-size";
export type { FontSize } from "./settings/font-size";

export { WIDGET_EVENT_NAMES } from "./events/widget-events";
export type { WidgetEventName, WidgetEventPayload } from "./events/widget-events";
